import { Box, Button, Typography } from '@mui/material'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'

interface IProps {
  actionText: string
  description: string
  disabled: boolean
  onClick?: () => void
}

export const ActionItem = ({ actionText, description, disabled, onClick }: IProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '12px',
      }}
    >
      <Button
        sx={{ fontSize: '14px', padding: '8px 16px', textTransform: 'none', borderRadius: '20px' }}
        variant="contained"
        endIcon={<ArrowForwardIosIcon />}
        disabled={disabled}
        onClick={onClick}
      >
        {actionText}
      </Button>
      <Typography variant="body2" align="center">
        {description}
      </Typography>
    </Box>
  )
}
